/**
 * The `app.py` settings the AI-Native template's `CallAIModel.py` reads
 * (`app.AI_GATEWAY_URL`, `app.LANGFUSE_HOST`, `app.LANGFUSE_BASIC_AUTH_KEY`).
 * Their values come from the platform's environment, per env, so the file
 * only says where to read them — the same lines the template's own solution
 * has. Pure: the store uploads the result.
 */

export const AI_GATEWAY_SETTINGS = `# AI Gateway and Langfuse, for CallAIModel.py. The platform sets the values
# for each environment; nothing secret is kept in this file.
AI_GATEWAY_URL = os.getenv('AI_GATEWAY_URL')
LANGFUSE_BASIC_AUTH_KEY = os.getenv('LANGFUSE_BASIC_AUTH_KEY')
LANGFUSE_HOST = os.getenv('LANGFUSE_HOST')
`;

/**
 * `app.py` with the settings added after its imports, or unchanged when it
 * already sets `AI_GATEWAY_URL`. Adds `import os` when it's missing.
 */
export const withAiGatewaySettings = (appPy: string): string => {
  if (/^\s*AI_GATEWAY_URL\s*=/m.test(appPy)) return appPy;
  const source = /^\s*import os\b/m.test(appPy) ? appPy : `import os\n${appPy}`;
  const lines = source.split('\n');
  // After the last top-level import, before the rest of the module.
  let at = -1;
  lines.forEach((line, i) => {
    if (/^(import|from)\s/.test(line)) at = i;
  });
  lines.splice(at + 1, 0, '', AI_GATEWAY_SETTINGS.trimEnd());
  return lines.join('\n');
};
